import React from 'react';
import TurfBookingsForm from './TurfBookingsForm';

const NewTurfBookingPage = () => {
    return <TurfBookingsForm formType="create" />;
};

export default NewTurfBookingPage;
